import config from "@services/config";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import React, { useEffect } from "react";

type SEOProps = {
  pageTitle?: string;
  pageDescription?: string;
  image?: string;
};

const SEO: React.FC<SEOProps> = ({ pageTitle = config.siteName, pageDescription = config.siteDescription, image }) => {
  const title = pageTitle;
  const desc = pageDescription;
  const ogImgRelativePath = "/dw-logo.png";

  const siteURL = config.siteUrl;
  const ogImageURL = image ? `https:${image}` : `${siteURL}${ogImgRelativePath}`;
  const ogImageAlt = image ? pageTitle : "DeathroW Logo";
  const pathName = useRouter().pathname;
  const pageURL = pathName === "/" ? siteURL : siteURL + pathName;
  const twitterHandle = `@${config.twitterName}`;
  const siteName = config.siteName;

  return (
    <NextSeo
      title={title}
      description={desc}
      canonical={pageURL}
      openGraph={{
        type: "website",
        locale: "fr_FR",
        url: pageURL,
        title,
        description: desc,
        images: [
          {
            url: ogImageURL,
            width: 1200,
            height: 630,
            alt: ogImageAlt,
          },
        ],
        site_name: siteName,
      }}
      twitter={{
        handle: twitterHandle,
        site: twitterHandle,
        cardType: "summary_large_image",
      }}
      additionalMetaTags={[
        {
          property: "author",
          content: title,
        },
      ]}
      additionalLinkTags={[
        {
          rel: "icon",
          href: `${siteURL}/favicon.ico`,
        },
        {
          rel: "manifest",
          href: "/site.manifest",
        },
      ]}
    />
  );
};

export default SEO;
